import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from 'prop-types';
import { showAssistanceComponent } from "../NeedAssistance/action";
import NeedAssistanceConfirmComponent from "./NeedAssistanceConfirm/NeedAssistanceConfirm";
import NeedAssistanceSubmissionComponent from "./NeedAssistanceSubmission/NeedAssistanceSubmission";
import {
  DrawerWrapper,
  BottomHeader,
  ContactPara,
  NeedAssistanceFooter
} from "./style";
import { needAssistanceDerivedStates } from "./selectors";

export class NeedAssistancePage extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <DrawerWrapper
        className="need-assistance"
        visible={this.props.visible}
        placement={window.innerWidth < 991.92 ? "top" : "right"}
        onClose={this.props.onClose}
      >
        {this.props.drawerCondition ? (
          <NeedAssistanceConfirmComponent
            data-test="need-asst-confirm"
            assistanceConfirmHandler={() => this.props.closePage}
          />
        ) : (
            <NeedAssistanceSubmissionComponent />
          )}
        <NeedAssistanceFooter>
          <BottomHeader>Hit a snag?</BottomHeader>
          <ContactPara>Contact us at 888-383-4483</ContactPara>
        </NeedAssistanceFooter>
      </DrawerWrapper>
    );
  }
}
NeedAssistancePage.propTypes = {
  visible: PropTypes.bool,
};

const mapStateToProps = state => ({
  ...needAssistanceDerivedStates(state.toJS())
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(showAssistanceComponent())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NeedAssistancePage);
